module.exports = __webpack_public_path__ + "img/engagement_rings.abe65f2.webp";